
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myCourseMenuFilter } from '@xt/client/dataSource/my/index'
import MyLayout from '../views/MyLayout/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    MyLayout
  },
  asyncData(ctx) {
    // 格式化合并路由参数
    const filterForm = ctx.store.$myV2.Course.parserQuery(ctx.query)

    return {
      filterForm
    }
  }
})
export default class CoursePage extends Vue {
  filterForm: {
    courseType: string
    contentType: string
  }

  // 内容区筛选项变化
  get filterList() {
    return myCourseMenuFilter.find(item => item.value === this.filterForm.contentType)?.filters || []
  }

  get MyStore() {
    return this.$store.$myV2.Course
  }

  get myCourseMenu() {
    return myCourseMenuFilter
  }

  // 更新筛选条件
  updateFilterForm(
    item: Partial<{
      courseType: string
      contentType: string
    }>
  ) {
    this.filterForm = {
      ...this.filterForm,
      ...item
    }

    const seachForm = this.MyStore.toSearchQuery(this.filterForm)

    this.$router.replace({
      query: {
        ...seachForm
      }
    })

    document.documentElement.scrollTo({ top: 0 })
  }

  // 点击内容区筛选项
  handleFilterChange(key: string) {
    if (this.filterForm.courseType === key) return

    this.updateFilterForm({
      courseType: key
    })
  }

  // 点击左侧菜单项
  handleMenuChange(key: string) {
    this.updateFilterForm({
      contentType: key,
      courseType: ''
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
